export const stringToHex = str => {
  let color = '#'

  const hash = str
    .split('')
    .reduce((hash, l) => l.charCodeAt(0) + ((hash << 5) - hash), 0)
  for (let i = 0; i < 3; i++) {
    color += ('00', ((hash >> (i * 8)) & 0xff).toString(16)).substr(-2)
  }

  return color
}

export const contrastHex = (hex, aColor, bColor) => {
  aColor = aColor || 'black'
  bColor = bColor || 'white'

  const rgb = hexToRgb(hex)

  if (!rgb) {
    return aColor
  }

  if ((rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 255000 >= 0.5) {
    return aColor
  }

  return bColor
}

export const hexToRgb = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null
}

export default {
  stringToHex,
  contrastHex,
  hexToRgb
}



// WEBPACK FOOTER //
// ./src/utils/color.js